import React from 'react'
import queryString from 'query-string'
import styled from 'styled-components'
import { Box, Label } from 'pcln-design-system'
import { ExternalLink as ExternalLinkIcon } from 'pcln-icons'
import { LOCATION_SEARCH_TYPE } from '../../types'

type TripsUrlValues = {
  adultCount: number
  childrenAges: number[]
  childrenCount: number
  endDate: string
  endLocationObject?: Partial<LOCATION_SEARCH_TYPE>
  flightItineraryTypeCode?: string
  hotelEndDate?: string
  hotelStartDate?: string
  isMultiHotel?: boolean
  locationObject?: Partial<LOCATION_SEARCH_TYPE>
  partialStay?: boolean
  roomCount: number
  startDate: string
  startLocationObject?: Partial<LOCATION_SEARCH_TYPE>
  tripType: string
}

export type OpenTripsLinkProps = {
  color?: string
  isMultiHotel?: boolean
  linkText: string
  onClick: () => void
  values: TripsUrlValues
}

const StyledExternalLinkIcon = styled(ExternalLinkIcon)`
  position: relative;
  top: 6px;
`

const StyledLabel = styled(Label)`
  cursor: pointer;
`

export const formatTripsUrl = ({
  adultCount,
  childrenAges,
  childrenCount,
  endDate,
  endLocationObject,
  flightItineraryTypeCode,
  hotelEndDate,
  hotelStartDate,
  isMultiHotel,
  locationObject,
  partialStay,
  roomCount,
  startDate,
  startLocationObject,
  tripType
}: TripsUrlValues): string => {
  const hotelLocationObject = locationObject || endLocationObject
  return queryString.stringify({
    'destination-city': hotelLocationObject?.cityName,
    'destination-country-code': hotelLocationObject?.countryCode,
    'destination-country': hotelLocationObject?.country,
    'destination-id': hotelLocationObject?.id,
    'destination-item': hotelLocationObject?.itemName,
    'destination-state-code': hotelLocationObject?.stateCode,
    'destination-state': hotelLocationObject?.provinceName,
    'destination-type': hotelLocationObject?.type,
    'flight-code': flightItineraryTypeCode,
    'origin-city': startLocationObject?.cityName,
    'origin-country-code': startLocationObject?.countryCode,
    'origin-country': startLocationObject?.country,
    'origin-id': startLocationObject?.id,
    'origin-item': startLocationObject?.itemName,
    'origin-type': startLocationObject?.type,
    'trip-type': tripType,
    adults: adultCount,
    ages: JSON.stringify(childrenAges),
    children: childrenCount,
    end: endDate,
    openMultiHotel: isMultiHotel,
    rooms: roomCount,
    start: startDate,
    ...(partialStay
      ? {
          'hotel-start': hotelStartDate,
          'hotel-end': hotelEndDate
        }
      : {})
  })
}

const openTripsWithPrepop = (values: TripsUrlValues) => {
  const url = formatTripsUrl(values)
  window.open(`/trips/?${url}`, '_blank')
}

const OpenTripsWithPrepopLink = ({
  color,
  linkText,
  onClick,
  values
}: OpenTripsLinkProps) => {
  return (
    <Box>
      <StyledLabel
        nowrap
        fontSize={0}
        mt={[2, '-6px']}
        mb={[1, 0]}
        ml={1}
        color={color}
        onClick={() => {
          onClick()
          openTripsWithPrepop(values)
        }}
      >
        <StyledExternalLinkIcon size={18} mr="5px" />
        {` ${linkText}`}
      </StyledLabel>
    </Box>
  )
}

export default OpenTripsWithPrepopLink
